<template>
  <div>
    <Loader v-if="!dataTree.length" :isLoading="true" />
    <div
      v-else
      class="card"
      style="min-height:100px; padding-top:5px;padding-bottom:50px;"
    >
      <div v-if="this.errors === false">
        <ul style="margin-top:5px" v-for="item in this.dataTree" :key="item.id">
          <ItemTreeComponent
            style="font-size:12px;"
            :isOpen="isOpen"
            class="item"
            :item="item"
          />
        </ul>
      </div>
      <div style="color:red;" v-else>{{ $t('tree.notranslation') }}</div>
    </div>
  </div>
</template>

<script>
import ItemTreeComponent from './ItemTreeComponent'
import TreeFoldingButton from './TreeFoldingButton'
import { mapGetters } from 'vuex'
import Loader from '@/components/layout/Loader'

export default {
  name: 'TreeComponent',
  props: {
    data: Array
  },
  components: {
    ItemTreeComponent,
    TreeFoldingButton,
    Loader
  },
  updated () {
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  },
  data: function () {
    return {
      isOpen: true,
      dataTreeQuestions: [],
      references: null,
      prototype: [],
      tree: [],
      children: {},
      index: null,
      dataTree: [],
      test: [],
      NbConditionalByAnswer: 0,
      errors: false
    }
  },
  computed: {
    ...mapGetters(['choosenLanguageClient', 'sections'])
  },
  watch: {
    choosenLanguageClient: function () {
      this.pre()
    },
    sections: function () {
      this.pre()
    }
  },
  created () {
    // this.pre()
  },
  methods: {
    pre () {
      this.errors = false
      this.dataTree = this.sections
      // we test if all answers contains conditional section
      this.dataTree.map((section, indexSection) => {
        section.questions.map((question, indexQuestion) => {
          if (question.answers.length) {
            question.answers.map((answer, indexAnswer) => {
              if (
                answer.conditional_section !== null &&
                this.dataTree[indexSection].questions.length > indexQuestion + 1
              ) {
                this.NbConditionalByAnswer += 1
                if (question.answers.length === this.NbConditionalByAnswer) {
                  this.dataTree[indexSection].questions = this.dataTree[
                    indexSection
                  ].questions.splice(indexQuestion, 1)
                }
              }
            })
          }
        })
      })
      // start the recursive at index "0"
      this.dataTree = this.recursive(0)
    },
    recursive (idSection) {
      // we return a real id (i.e '67', not index) or index if the first index '0'
      if (idSection >= 0) {
        for (let i = 0; i < this.dataTree.length; i++) {
          if (this.dataTree[i].id === idSection) {
            idSection = i
          }
        }
      }
      if (idSection !== null) {
        // we create an object to add css and children so that to create a tree recursive
        return this.dataTree[idSection].questions.map(
          (question, indexQuestion) => ({
            id: indexQuestion + 1,
            type: 'question',
            name: this.checkLanguageQuestion(question),
            children: this.childrenCheckContainsContentTextOrNotation(
              question,
              idSection,
              indexQuestion
            )
          })
        )
      }
    },
    // we check the language and return the right translated question
    checkLanguageQuestion (question) {
      if (this.$store.state.langage.langue === 'fr') {
        if (question.entitled === null) this.errors = true
        else return question.entitled
      } else if (this.$store.state.langage.langue === 'en') {
        if (question.entitled_en === null) this.errors = true
        else return question.entitled_en
      } else if (this.$store.state.langage.langue === 'es') {
        if (question.entitled_es === null) this.errors = true
        else return question.entitled_es
      } else if (this.$store.state.langage.langue === 'de') {
        if (question.entitled_de === null) this.errors = true
        else return question.entitled_de
      }
    },
    checkLanguageAnswers (answer) {
      if (this.$store.state.langage.langue === 'fr') {
        if (answer.entitled === null) this.errors = true
        else return answer.entitled
      } else if (this.$store.state.langage.langue === 'en') {
        if (answer.entitled_en === null) this.errors = true
        else return answer.entitled_en
      } else if (this.$store.state.langage.langue === 'es') {
        if (answer.entitled_es === null) this.errors = true
        else return answer.entitled_es
      } else if (this.$store.state.langage.langue === 'de') {
        if (answer.entitled_de === null) this.errors = true
        else return answer.entitled_de
      }
    },
    // we check if children contains a 'content' type, or a 'notation' type of question
    // because the treatement is different there is or is not
    childrenCheckContainsContentTextOrNotation (
      question,
      idSection,
      indexQuestion
    ) {
      if (question.element_type === 'content') {
        return [
          {
            name: this.$i18n.t('tree.conditional.content'),
            children:
              this.dataTree[idSection + 1] !== undefined
                ? this.recursive(this.dataTree[idSection + 1].id)
                : null
          }
        ]
      } else if (question.element_type === 'notation') {
        return [
          {
            name: this.$i18n.t('tree.conditional.notation'),
            children:
              this.dataTree[idSection + 1] !== undefined
                ? this.recursive(this.dataTree[idSection + 1].id)
                : null
          }
        ]
      } else {
        return question.answers.map((answer, indexAnswer) => ({
          id: indexAnswer + 1,
          lengthArrayAnswers: question.answers.length,
          name:
            answer.entitled !== ''
              ? this.checkLanguageAnswers(answer)
              : this.$i18n.t('tree.conditional.content.answer'),
          children: this.knowIdForRecursive(answer, idSection, indexQuestion)
        }))
      }
    },
    // we check if we are not at the end of the survey (e.i '-1')
    // if is not, we plays the recursive with the right id
    knowIdForRecursive (answer, indexSection, indexQuestion) {
      if (answer.conditional_section !== -1) {
        // if not the end, plays the recursive with the 'conditonal_id'
        if (answer.next_section !== null) {
          if (answer.conditional_section !== null) {
            return this.recursive(answer.conditional_section)
          }
          // we check if we are at the end of questions array
          // and check if it's the end of array section
          // if is not, we play the recursive
          if (
            indexQuestion + 1 ===
            this.dataTree[indexSection].questions.length
          ) {
            if (this.dataTree[indexSection + 1] !== undefined) {
              let realId = this.dataTree[indexSection + 1].id
              return this.recursive(realId)
            }
          }
        }
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
.dot {
  display: inline-block;
  background-color: black;
  height: 10px;
  width: 10px;
}
.dotContainer {
  margin-top: 1.5em;
  margin-bottom: 1em;
  display: flex;
  justify-content: space-between;
  max-width: 350px;
}
.wrapper {
  height: 200px;
  display: flex;
}
.boite {
  padding: 4px;
  margin-bottom: 2px;
  margin-top: 2px;
  border: 1px solid grey;
}
.branch-question {
  width: 25px;
  height: 8px;
  border-bottom: solid 2px black;
}
.branch-section {
  width: 25px;
  height: 1x;
  border: solid 1px black;
}
.branch-section-vertical {
  width: 1px;
  border: solid 1px black;
}
.container-questions {
  display: flex;
  align-items: center;
}
.section {
  display: flex;
  align-items: center;
}
body {
  font-family: Menlo, Consolas, monospace;
  color: #444;
}
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>



// WEBPACK FOOTER //
// src/components/question/section/tree/TreeComponent.vue